import DropdownTemplateView from '../../../../DropdownTemplateView'
import SimpleMenu, { Option } from '../../../../components/SimpleMenu'
import messageResource from '../../../../messageResource'
import $ from 'jquery'
import ClassicBridge from '../../../../next/ClassicBridge'

export default class RegularNonworkingDayEditor extends DropdownTemplateView {
    constructor({
        leaveBlackoutEnabled,
        editCorporateCallback = () => {},
        deleteCorporateCallback = () => {},
        addLeaveBlackoutCallback = () => {},
        deleteLeaevBlackoutCallback = () => {},
        openDeleteNonApprovedLeaveRequestsConfirmationCallback = () => {}
    } = {}) {
        super()

        this.callbacks = {
            editCorporateCallback,
            deleteCorporateCallback,
            addLeaveBlackoutCallback,
            deleteLeaevBlackoutCallback,
            openDeleteNonApprovedLeaveRequestsConfirmationCallback
        }

        this.state = {
            date: null,
            nonStandardWorking: false,
            isLeaveBlackout: false,
        }

        this._leaveBlackoutEnabled = leaveBlackoutEnabled

        this.onStatePropertyChanged('nonStandardWorking', (isWorking) => {
            this.$markAsWorkingButton.setState({
                title: messageResource.getMessage(isWorking ? 'work_schedule.mark_as_regular_nonworking_day' : 'work_schedule.mark_as_working_day'),
            })
        })
        this.onStatePropertyChanged('isLeaveBlackout', (isLeaveBlackout) => {
            if (this._leaveBlackoutEnabled) {
                this.$markAsLeaveBlackoutButton.setState({
                    title: messageResource.getMessage(isLeaveBlackout ? 'work_schedule.remove_leave_blackout' : 'work_schedule.set_leave_blackout'),
                })
            }
        })
    }

    templateHtml() {
        return "<div class='regularNonworkingDayEditorContainer' />"
    }

    afterRender() {
        this.simpleMenu = new SimpleMenu().init(this.$el)

        if (this._leaveBlackoutEnabled) {
            this.$markAsLeaveBlackoutButton = new Option({
                onSelected: () => {
                    if (this.state.isLeaveBlackout) {
                        this.callbacks.deleteLeaevBlackoutCallback(this.state.date)
                        this.hide()
                    } else {
                        this.$markAsLeaveBlackoutButton.setState({ isLoading: true })
                    ClassicBridge
                        .getNonApprovedLeaveRequestsForDay(this.state.date)
                        .then((nonApprovedLeaveRequestsCount) => {
                            if (nonApprovedLeaveRequestsCount)
                                this.callbacks.openDeleteNonApprovedLeaveRequestsConfirmationCallback(this.$elementShowAt, this.state.date, nonApprovedLeaveRequestsCount)
                            else
                                this.callbacks.addLeaveBlackoutCallback(this.state.date)
                        })
                        .finally(() => {
                            this.$markAsLeaveBlackoutButton.setState({ isLoading: false })
                            this.hide()
                        })
                    }
                }
            }).init(this.simpleMenu.$el)
        }

        this.$markAsWorkingButton = new Option({
            onSelected: () => {
                if (this.state.nonStandardWorking) {
                    this.callbacks.deleteCorporateCallback(this.state.date)
                } else {
                    this.callbacks.editCorporateCallback(this.state.date, true, '', this.state.isLeaveBlackout)
                }
                this.hide()
            }
        }).init(this.simpleMenu.$el)

        this.$markAsHolidayButton = new Option({
            onSelected: () => {
                this.callbacks.editCorporateCallback(this.state.date, false, messageResource.getMessage('work_schedule.corporate_holiday'), this.state.isLeaveBlackout)
                this.hide()
            }
        }).init(this.simpleMenu.$el)

        this.$markAsHolidayButton.setState({
            title: messageResource.getMessage('work_schedule.mark_as_holiday'),
        })

        this.renderInitialState()
    }

    setOnHideCallback(callback) {
        this.onHideCallback = callback
    }

    setOnShowCallback(callback) {
        this.onShowCallback = callback
    }

    onHide() {
        super.onHide()
        this.onHideCallback()
    }

    onShow() {
        super.onShow()
        this.onShowCallback()
    }

    mouseDownTargetElement() {
        return $(document)
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/workSchedule/components/month/RegularNonworkingDayEditor.js